import packageJson from "./../../package.json";
// import firebaseConfig from "./firebase";

if (process.env.NODE_ENV === "production") {
  const variables = [
    "REACT_APP_APOLLO_URI",
    // "REACT_APP_SENTRY_DSN"
  ];
  for (let variable of variables) {
    if (!process.env[variable]) {
      throw new Error(`Kindly Provide Variable ${variable} In Env`);
    }
  }
}

const appEnv = process.env.REACT_APP_ENV!

interface Config {
  env: "production" | "staging" | "sandbox" | "test" | "development";
  name: string;
  asset: {
    uri: string;
  };
  apollo: {
    uri: string;
    name: string;
    version: string;
  };
  sentry: {
    dsn: string;
    env: "production" | "staging" | "sandbox" | "test";
  };
  cookies: {
    domain: string;
    secure: boolean;
    sameSite: "strict" | "Strict" | "lax" | "Lax" | "none" | "None";
  };
  constants: {
    page: number;
    pageSize: number;
    dateFormat: string;
  };
  stripe: {
    key: string;
  }
}

const config: Config = {
  env: (process.env.NODE_ENV as any) ?? "development",

  name: packageJson.name,
  asset: {
    uri: process.env.REACT_APP_ASSET_URI ?? "http://127.0.0.1:4000/api/assets",
  },
  apollo: {
    uri: appEnv === "production" ? process.env.REACT_APP_APOLLO_URI! : "https://tendo-core.fly.dev/graph",
    name: packageJson.name,
    version: packageJson.version,
  },
  sentry: {
    dsn:
      process.env.REACT_APP_SENTRY_DSN ??
      "https://examplePublicKey@o0.ingest.sentry.io/0",
    env: process.env.REACT_APP_SENTRY_ENV as any,
  },
  cookies: {
    domain: window.location.hostname?.split(".")?.slice(1)?.join("."),
    secure: true,
    sameSite: "strict",
  },
  constants: {
    page: 1,
    pageSize: 10,
    dateFormat: "",
  },
  stripe: {
    key: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ?? "",
  }
};

export default config;
